import { EasFormGroup } from "@fry/components/common/easform"
import { EasBuilderGroup } from "@fry/components/common/form-builder/builder.interfaces"
import { SearchModel } from "@fry/lib/list"

export enum AsyncTaskStates {
    DRAFT = 'draft',
    PREPARING = 'preparing',
    NEW = 'new',
    SUCCESS = 'success',
    FAILURE = 'failure',
    ABORTED = 'aborted',
    PROCESSING = 'processing',
    PROGRESS = 'progress',
}

export interface AsyncTaskMeta {
  errors?: number,
  inner_state: number,
  processed: number,
  total: number
}

export enum AsyncTaskWizardSteps {
  STEP_1 = 'step1',
  STEP_2 = 'step2',
  STEP_3 = 'step3',
  STEP_4 = 'step4',
  STEP_5 = 'step5',
  STEP_6 = 'step6',
}

export interface WizardDataSourceIds {
  ids: string[],
  searchCriteria: undefined
}

export interface WizardDataSourceSearch {
  ids: undefined,
  searchCriteria: any
}

export interface WizardDataSource {
  ids?: string[],
  searchCriteria?: any
}

export interface AsyncTaskWizardData {
  source: WizardDataSource,
  params: any,
  fixedSearch?: SearchModel,
  search?: SearchModel,
}

export interface AsyncTaskWizardHelpers {
  currentStep: AsyncTaskWizardSteps,
  selectedAction?: string,
}



export interface AsyncTaskWizardDoc {
  _id: string,
  _rev?: string,
  createdDate?: string,
  meta?: any,
  tool: string,
  itemDocType: string,
  state: AsyncTaskStates,
  origin?: {
    path: string,
    title?: string,
  },
  wizardData: AsyncTaskWizardHelpers,
  data: AsyncTaskWizardData,
  action?: string,
  actionName?: string,
  wizardHelpers?: {
    selectedAction?: AsyncTaskAction,
    steps?: AsyncTaskOptionStep[],
  }
}


export interface AsyncTaskDoc {
  _id: string,
  _rev?: string,
  state: AsyncTaskStates
}

export interface AsyncTaskAction {
  id: string,
  action: string,
  label: string,
  status: string,
  status_reason?: string,
  action_defaults: any
}

export interface AsyncTaskAvailableActions {
  available: AsyncTaskAction[],
  not_available: AsyncTaskAction[],
  out_of_scope_cnt: number,
}

export interface AsyncTaskOptionStep {
  id: string,
  label: string,
}

export interface AsyncTaskOptionStepForm {
  form: EasBuilderGroup,
  initial: any
}

export interface AsyncTaskOptionForm {
  id: string,
  label: string,
  form: EasFormGroup | null
}

export interface AsyncTaskOutputSummaryPerItem {
  created?: number;
  not_created?: number;
  exists?: number;
  no_changes?: number;
  updated?: number;
  errors?: number;
}

export interface AsyncTaskOutputSummary {
  id: string;
  state: AsyncTaskStates;
  meta?: {
    inner_state: "done" | "progress" | "new";
    processed: number;
    total: number;
    rate_complete?: number;
  }
  outputSummary?: AsyncTaskOutputSummaryPerItem
}
